
export const defaultLocale = 'en';
export const localeOptions=[
    { id:'id',name:'Bahasa Indonesia',icon:'flag-icon-id' },
    { id:'en',name:'English',icon:'flag-icon-us' },
];
